export default __webpack_public_path__ + "static/media/e-procurement.d1e11987.webp";